import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsMontage() {
  const descriptionList = [
    "Vous souhaitez un PC puissant et optimisé pour le gaming, le montage vidéo ou un usage professionnel ? Nous vous proposons un service de montage sur-mesure, adapté à vos besoins et à votre budget.",
    "Ce service comporte deux étapes :",
    "Conseil et sélection des composants si vous ne savez pas quoi acheter (Si vous avez déjà la liste de vos composant) (supplément 30€).",
    "Montage et installation une fois les pièces acquises par vos soins.",
  ];
  const deroulementList = [
    "1 Premier rendez-vous (optionnel) - Conseil et sélection des composants : Discussion sur vos besoins et votre budget. Proposition d'une configuration optimisée (processeur, carte graphique, RAM, stockage, alimentation…). Remise d'une liste de composants à commander. (Supplément pour cette prestation)",
    "2 Second rendez-vous - Montage du PC : Vérification des composants avant assemblage. Montage complet : Installation du processeur, carte mère, RAM, carte graphique, stockage, alimentation, câblage propre et ventilation optimisée. Premiers tests pour vérifier le bon fonctionnement du matériel.",
    "3 Installation et optimisation (optionnel) : Installation du système d'exploitation (Windows, Linux, etc.) et des pilotes. Paramétrage du BIOS et optimisation des performances. Installation des logiciels essentiels et des mises à jour (supplément).",
    "4 Tests finaux et restitution : Vérification de la stabilité du système et des températures et conseils d'entretien.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="MONTAGE PC SUR MESURE / GAMING"
        price="50€ euros TTC + Options"
        atelier={true}
        domicile={true}
        time="Variable"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="L'aide à la sélection des composants est de 30 € TTC, et l'installation du système d'exploitation et des logiciels est de 20 €." />
    </div>
  );
}

export default TarifsMontage;
